import Kit from 'containers/kit'

export default Kit
